import axios from 'axios'
import { Message, Loading } from 'element-ui'
import userInfoHelper from 'common/userInfo'
import qs from 'qs'
import cookies from 'js-cookie'

const METHODS = ['get', 'delete']
const BODY_METHODS = ['post', 'put', 'patch']
const http = {}
const axiosInstance = axios.create({
  headers: {
    'content-type': 'application/json',
    'Authorization-admin': cookies.get('admin-token'),
    Authorization: cookies.get('admin-token'),
    'Authorization-Send': cookies.get('send-token'),
  },
})
let loadingInstance
let requestQueue = 0

axiosInstance.interceptors.request.use(function (request) {
  // console.log('uuuuuuuuuuurr--',request);
  if (request.url.includes('otc-admin')) {
  }
  if (!requestQueue) {
    loadingInstance = Loading.service({
      fullscreen: false,
      target: document.querySelector('.el-table'),
      background: 'rgba(0, 0, 0, .8)',
    })
  }
  requestQueue++

  return request
})

axiosInstance.interceptors.response.use(
  function (response) {
    // console.log('func-response',response);
    requestQueue--
    if (!requestQueue) {
      loadingInstance.close()
    }
    if (response.data.status === 401 || response.data.msg === 'UNAUTHORIZED') {
      console.log('response', response)
      userInfoHelper.clear()
      window.location.href = '/'
      return
    }

    if (
      response.status !== 200 ||
      (response.data.status && response.data.status !== 200) ||
      response.data.code === -1
    ) {
      handleError(response)
      console.log('错误------------》', response)
      return Promise.reject(response.data.msg)
    }

    return response.data
  },
  function (error) {
    requestQueue--
    if (!requestQueue) {
      loadingInstance.close()
    }

    // console.log('error',error.response);
    // if(error.response.status===401 && error.response.statusText=='"Unauthorized"'){
    //   console.log('tuichu');
    //   window.location.href='/'
    //   return
    // }
    handleError(error.response)

    return Promise.reject(error)
  }
)

function handleError(res) {
  console.log('handlerError', res)
  Message({
    type: 'error',
    message: res.data
      ? res.data.message || res.data.msg || '服务异常，稍后重试' || '系统错误'
      : '未知错误！',
  })
  if (res.status == 401) {
    userInfoHelper.clear()
    window.location.href = '/'
    return
  }
}

function request(method, url, params, headers = {}, options = {}) {
  return axiosInstance.request({
    method,
    url,
    params,
    data: {},
    headers: {
      Authorization: userInfoHelper.get().accessToken,
      // 'Authorization-admin':cookies.get('Authorization-admin'),
      ...headers,
      'Authorization-admin': cookies.get('admin-token'),
      Authorization: cookies.get('admin-token'),
      'Authorization-Send': cookies.get('send-token'),
    },
    ...options,
  })
}

function requestWithBody(method, url, data = {}, headers = {}, options = {}) {
  return axiosInstance.request({
    method,
    url,
    data,
    headers: {
      Authorization: userInfoHelper.get().accessToken,
      ...headers,
      'Authorization-admin': cookies.get('admin-token'),
      Authorization: cookies.get('admin-token'),
      'Authorization-Send': cookies.get('send-token'),
    },
    ...options,
  })
}

function init() {
  for (let method of METHODS) {
    http[method] = ({ url, data, headers, dataType, ...options }) => {
      let __data = data
      let __headers = headers || {}

      if (dataType === 'form') {
        __data = qs.stringify(data)
        __headers = Object.assign(__headers, {
          'content-type': 'application/x-www-form-urlencoded',
          'Authorization-admin': cookies.get('admin-token'),
          Authorization: cookies.get('admin-token'),
          'Authorization-Send': cookies.get('send-token'),
        })
      }

      return request(method, url, __data, __headers, options)
    }
  }

  for (let method of BODY_METHODS) {
    http[method] = ({ url, data, headers, dataType, ...options }) => {
      let __data = data
      let __headers = headers || {}

      if (dataType === 'form') {
        __data = qs.stringify(data)
        __headers = Object.assign(__headers, {
          'content-type': 'application/x-www-form-urlencoded',
          'Authorization-admin': cookies.get('admin-token'),
          Authorization: cookies.get('admin-token'),
          'Authorization-Send': cookies.get('send-token'),
        })
      }

      if (dataType === 'file') {
        __data = new FormData()

        __data.append('file', data)
        __headers = Object.assign(__headers, {
          'content-type': 'multipart/form-data',
          'Authorization-admin': cookies.get('admin-token'),
          Authorization: cookies.get('admin-token'),
          'Authorization-Send': cookies.get('send-token'),
        })
      }

      return requestWithBody(method, url, __data, __headers, options)
    }
  }

  return http
}

function createPlugin() {
  return {
    install: (Vue) => {
      Object.defineProperty(Vue.prototype, '$axios', {
        get() {
          return init()
        },
      })
    },
  }
}

export const createAxiosPlugin = createPlugin
export default init()
